/* Place your global variable definitons here */
